import React, { useState, useEffect, useRef } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../../../src/Config";
import PaginationView from "../../../Component/PaginationView";

function CylinderLogs({ isSidebarExpanded }) {
  const [logs, setLogs] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams(); // This is correct

  const fetchLogs = async () => {
    console.log("cylinderid",id)
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/cylinder_inventory_logs`, {
        headers: { Authorization: authKey },
        params: id ? { gas_cylinder_id: id } : {},
      });

      const logsData = response.data.cylinder_inventory_logs || [];
      setLogs(logsData);
      setTotalItems(logsData.length);
      setError("");
    } catch (err) {
      console.error("Error fetching cylinder logs:", err);
      setError("Failed to fetch logs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [id, currentPage]);

  const handleBack = () => {
    navigate(-1);
  };

  const paginatedLogs = logs.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div
      className={`main-container page-content${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div
        className={`data-lists-content-container page-contents ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <div className="data-list-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    style={{ fontSize: "20px", cursor: "pointer", marginRight: "8px" }}
                    onClick={handleBack}
                  />
                </Tooltip>
                Cylinder Logs
              </div>
            </div>
          </div>

          <div className="data-list-body">
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <p style={{ textAlign: "center" }}>Loading...</p>
                ) : error ? (
                  <p style={{ textAlign: "center", color: "red" }}>{error}</p>
                ) : (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th>SR. NO.</th>
                        <th>ACTIONS</th>
                        <th>VOLUME</th>
                        <th>REMARKS</th>
                        <th>DATE</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {paginatedLogs.length === 0 ? (
                        <tr>
                          <td colSpan="6" style={{ textAlign: "center" }}>
                            No Cylinder Logs found.
                          </td>
                        </tr>
                      ) : (
                        paginatedLogs.map((log, index) => (
                          <tr key={log.id || index} className="hoverable-row">
                            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                            <td>{log.action || "NA"}</td>
                            <td>{log.volume || "NA"}</td>
                            <td>{log.notes || "NA"}</td>
                            <td>{log.created_at ? new Date(log.created_at).toLocaleString() : "NA"}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}

                <PaginationView
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CylinderLogs;
